import React from 'react';
/**
 * @todo This is a placeholder for a AI Hub PageError fallback render that would make use of the error
 * component context to show correlationId and sessionId and a nice error message
 * @returns a PageError fallback render
 */
export var AiHubErrorPage = function (_a) {
    var error = _a.error, moduleName = _a.moduleName;
    return (React.createElement("div", null,
        React.createElement("h1", null, "Something went wrong"),
        React.createElement("details", { style: { whiteSpace: 'pre-wrap' } },
            error && React.createElement("summary", null, error.toString()),
            moduleName && React.createElement("p", null,
                "Module: ",
                moduleName))));
};
//# sourceMappingURL=AiHubErrorPage.js.map